<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <el-form ref="form" :model="form" :label-width="labelWidth" :rules="rules" :inline="true">
      <FormItem v-for="(c, i) in formCtrl.slice(0, 1)" :key="'formItem' + i" :viewMode="viewMode" :config="c"
        :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />

      <FormItem v-show="showLicense" :viewMode="licenseCtrl.viewMode" :config="licenseCtrl"
        :inputValue="form[licenseCtrl.keyName]" />

      <FormItem v-for="(c, i) in formCtrl.slice(1, 5)" :key="'formItem1' + i" :viewMode="viewMode" :config="c"
        :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
      <div>
        <FormItem v-for="(c, i) in formCtrl.slice(5)" :key="'formItem2' + i" :viewMode="viewMode" :config="c"
          :options="c.options" :inputValue="form[c.keyName]" @onChange="onChange" />
      </div>
    </el-form>

    <div class="btns">
      <SubmitBtn v-if="mode != 'view'" :editMode="mode === 'edit'" @onSubmit="onSubmit"></SubmitBtn>
      <el-button @click="cancel">取 消</el-button>
    </div>
  </div>
</template>

<script>
import detailMixin from "../../mixin/detail";
import mixin from "./mixin";

export default {
  mixins: [detailMixin, mixin],
  data() {
    return {
      viewMode: false,
      baseUrl: 'trailer',
      breadcrumb: [
        { name: "车辆管理", path: `/vehicle/hang` },
        { name: "挂车管理", path: `/vehicle/hang` },
        { name: "挂车添加" },
      ],
      form: {
        trailer: undefined,
        ton: undefined,
        buytime: undefined,
      },
      rules: {
        trailer: [
          { required: true, message: "请填写挂车号", trigger: "blur" },
        ],
        ton: [
          { required: true, message: "请填写核定载重", trigger: "blur" },
        ],
        buytime: [
          { required: true, message: "请选择车辆购入时间", trigger: "blur" },
        ],
      },
    };
  },
  methods: {},
  mounted() { },
};
</script>

<style lang="less" scoped>
/deep/ .el-form {
  background-color: #fff;
  padding-top: 20px;
  border-radius: 5px;
  box-shadow: 0px 0px 10px rgb(0 0 0 / 3%);

  .el-form-item {
    // border-bottom: 1px solid #f2f6fc;
    padding: 0 20px 15px 0;

    .el-form-item__content {
      .el-input {
        width: 300px;
      }

      .el-input.upload {
        width: 100%;
        min-width: 300px;
      }

    }
  }
}

.btns {
  margin: 40px 0 60px 180px;
}
</style>
